<template>
  <div class="viewport">
    <h1>The Restroom Archive</h1>
    <!-- Display restroom details -->
    <div v-if="restroom" class="restroom-details">
      <h2>
        <b>{{ restroom.name.toUpperCase() }}</b>
      </h2>
      <p>{{ restroom.date }}</p>
      <p>{{ restroom.location }}</p>
      <p>{{ restroom.coords }}</p>
    </div>
    <div v-else class="restroom-details">
      <p>No restroom selected.</p>
    </div>

    <!-- Attribution in bottom right, uncomment once you receive submissions! -->
    <!-- <div v-if="restroom" class="restroom-attribution">
      <p>Scanned by {{ restroom.attribution }}</p>
    </div> -->

    <!-- Loading animation -->
    <div v-if="loading" class="loading-animation">
      <img
        src="@/assets/gifs/toilet-loader.gif"
        alt="Loading..."
        width="200"
        height="200"
      />
    </div>

    <!-- Load the 3D model -->
    <Restroom
      v-if="restroom"
      :modelPath="restroom.file"
      :bgColor="0x000000"
      @model-loaded="handleModelLoaded"
      @model-loading="handleModelLoading"
    />
  </div>
</template>

<script>
  import { ref } from 'vue';
  import Restroom from './Restroom.vue';

  export default {
    name: 'Viewport',
    components: {
      Restroom,
    },
    props: {
      restroom: {
        type: Object,
        required: true,
      },
    },
    setup() {
      const loading = ref(false);

      // Trigger loading state when model starts loading
      const handleModelLoading = () => {
        loading.value = true;
      };

      // Delay hiding the loading animation to ensure smooth transition
      const handleModelLoaded = () => {
        setTimeout(() => {
          loading.value = false;
        }, 500); // Adjust delay as needed
      };

      return {
        loading,
        handleModelLoading,
        handleModelLoaded,
      };
    },
  };
</script>

<style scoped>
  .viewport {
    top: 0;
    border-top: 0.1px solid var(--color-1-solid);
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  h1 {
    font-family: satoshi;
    font-size: 18px;
    line-height: 0.5;
    z-index: 1000;
    position: absolute;
    color: var(--color-2-solid);
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    background-color: none;
    margin: 0;
    padding: 15px;
  }

  h2 {
    font-family: satoshi;
    font-size: 14px;
    line-height: 0.5em;
    color: var(--color-2-solid);
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  }

  p {
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  }
  .restroom-details {
    font-family: satoshi;
    font-size: 14px;
    line-height: 0.1em;
    color: var(--color-2-solid);
    position: absolute;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    bottom: 2.4em;
    margin-left: 1em;
    padding: 0.5em;
  }

  .restroom-attribution {
    font-family: satoshi;
    font-size: 14px;
    line-height: 0.1em;
    color: var(--color-2-solid);
    position: absolute;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    bottom: 2.4em;
    right: 1em;
    padding: 0.5em;
    text-align: right;
  }

  .loading-animation {
    position: fixed; /* Ensure it overlays the entire screen */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2000;
    background-color: rgba(
      0,
      0,
      0,
      0.5
    ); /* Optional: Add a semi-transparent background */
    width: 100vw; /* Full viewport width */
    height: 100vh; /* Full viewport height */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 14px;
    }
    .restroom-details {
      font-size: 12px;
      bottom: 1.8em;
      margin-left: 0.5em;
    }
    .restroom-attribution {
      font-size: 12px;
      bottom: 1.8em;
      right: 0.5em;
    }
  }
</style>
